import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1016.47059,903.047529 L1016.47059,1613.78635 L1202.37176,1427.88518 L1282.33412,1507.73459 L960,1829.95576 L637.665882,1507.73459 L717.628235,1427.88518 L903.529412,1613.78635 L903.529412,903.047529 L1016.47059,903.047529 Z M960,56 C1181.81647,56 1368.84706,199.661176 1438.08,398.211765 C1448.13176,397.534118 1458.07059,394.823529 1468.23529,394.823529 C1717.38353,394.823529 1920,597.44 1920,846.588235 C1920,1095.73647 1717.38353,1298.35294 1468.23529,1298.35294 L1468.23529,1298.35294 L1355.29412,1298.35294 L1355.29412,1185.41176 L1468.23529,1185.41176 C1655.04,1185.41176 1807.05882,1033.39294 1807.05882,846.588235 C1807.05882,659.783529 1655.04,507.764706 1468.23529,507.764706 C1466.31529,507.764706 1464.50824,508.329412 1462.58824,508.442353 C1464.73412,526.964706 1468.23529,545.148235 1468.23529,564.235294 C1468.23529,608.395294 1462.47529,652.329412 1451.29412,694.908235 L1451.29412,694.908235 L1342.08,665.995294 C1350.88941,632.790588 1355.29412,598.569412 1355.29412,564.235294 C1355.29412,346.258824 1177.97647,168.941176 960,168.941176 C747.557647,168.941176 574.870588,337.901176 566.4,548.310588 C604.574118,566.72 640.602353,590.098824 671.774118,620.592941 L671.774118,620.592941 L592.828235,701.345882 C539.745882,649.28 469.609412,620.705882 395.294118,620.705882 C239.548235,620.705882 112.941176,747.425882 112.941176,903.058824 C112.941176,1058.80471 239.548235,1185.41176 395.294118,1185.41176 L395.294118,1185.41176 L564.705882,1185.41176 L564.705882,1298.35294 L395.294118,1298.35294 C177.317647,1298.35294 0,1121.03529 0,903.058824 C0,685.082353 177.317647,507.764706 395.294118,507.764706 C416.188235,507.764706 436.517647,510.475294 456.847059,513.750588 C482.597647,257.487059 697.072941,56 960,56 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCloudDownloadLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCloudDownloadLine, _Component);

  var _super = _createSuper(IconCloudDownloadLine);

  function IconCloudDownloadLine() {
    _classCallCheck(this, IconCloudDownloadLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCloudDownloadLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCloudDownload",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCloudDownloadLine.displayName = "IconCloudDownloadLine";
  return IconCloudDownloadLine;
}(Component);

IconCloudDownloadLine.glyphName = 'cloud-download';
IconCloudDownloadLine.variant = 'Line';
IconCloudDownloadLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCloudDownloadLine;
export { IconCloudDownloadLine };